import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import { nodeIssues as nodeIssueActions } from '../actions';
import { nodeIssues as nodeIssueSelectors } from '../selectors';

import NodeHealthSummaryContainer from './NodeHealthSummaryContainer';
import NodeHealthDetailsContainer from './NodeHealthDetailsContainer';

export class NodeHealthContainer extends React.Component {
  static propTypes = {
    activeIssueTypeIds: PropTypes.arrayOf(PropTypes.string).isRequired,
    fetchActiveNodeIssues: PropTypes.func.isRequired,
    fetchNodeIssueTypes: PropTypes.func.isRequired
  }

  componentDidMount() {
    this.props.fetchActiveNodeIssues();
  }

  componentDidUpdate(prevProps) {
    if (this.props.activeIssueTypeIds !== prevProps.activeIssueTypeIds) {
      this.props.fetchNodeIssueTypes(this.props.activeIssueTypeIds);
    }
  }

  render() {
    return (
      <div>
        <Row>
          <Col>
            <NodeHealthSummaryContainer />
          </Col>
        </Row>
        <Row>
          <Col>
            <NodeHealthDetailsContainer />
          </Col>
        </Row>
      </div>
    );
  }
}

export const mapStateToProps = (state) => {
  const activeIssueTypeIds = nodeIssueSelectors.activeNodeIssueTypeIds(state);
  const props = { activeIssueTypeIds };
  return props;
};

export default connect(
  mapStateToProps,
  {
    fetchActiveNodeIssues: nodeIssueActions.fetchNodeActiveIssues,
    fetchNodeIssueTypes: nodeIssueActions.fetchNodeIssueTypes
  }
)(NodeHealthContainer);


// WEBPACK FOOTER //
// src/Containers/NodeHealthContainer.jsx